import history from '../history';

export const getClassesForPages = (classes: any) => {

  // checkout styles
  const checkoutStyles = (history.location.pathname === '/dashboard/plans/checkout')
    ? classes.dashboardCheckoutTheme
    : '';

  return checkoutStyles;
};
